import React from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

export default function PosiNegaTable({ negative, neutral, positive, total }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Total
            </TableCell>
            <TableCell align="right">{total}件</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              ポジティブ
            </TableCell>
            <TableCell align="right">{positive}件</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              ネガティブ
            </TableCell>
            <TableCell align="right">{negative}件</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              ニュートラル
            </TableCell>
            <TableCell align="right">{neutral}件</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
